import { TThunkAction } from '../../types/redux';
import { selectTotalCount } from '../../selectors/pagination';
import { fetchSeoData } from '../../services/fetchSeoData';
import { setSeoPageData } from './setSeoPageData';

interface IParams {
  queryString: string;
  seoUrl?: string;
}

export const updateSeoData = ({ queryString, seoUrl }: IParams): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const state = getState();
    const totalCount = selectTotalCount(state);

    const seoData =
      seoUrl || queryString
        ? await fetchSeoData(context, {
            query: seoUrl ? /* istanbul ignore next */ undefined : queryString,
            subdomain: context.custom.subdomain,
            uri: seoUrl,
            searchResultMetrics: { offersCount: totalCount },
          })
        : null;

    dispatch(setSeoPageData(seoData?.seoData || null));
  };
};
